import styled from 'styled-components';

import { Component } from './component';

export const Styled = styled(Component)`
  width: 1em;
  height: 1em;
  fill: currentColor;
`;
